import { InnerBox } from "@/components/elements/InnerBox";
import { CollapsibleSectionHeader, useCollapsible } from "@/features/talent/components/talent-common/CollapsibleSectionHeader";
import { DocumentTypeTagsReadOnly } from "@/features/talent/components/talent-detail/DocumentTypeTagsReadOnly";
import { TalentFileItem } from "@/features/talent/components/talent-detail/TalentFileItem";
import { useResolveDocumentTags } from "@/features/talent/hooks/useResolveDocumentTags";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Box, Collapse, Stack } from "@mui/material";

type TTalentCertificateFilesProps = {
  defaultValues?: Partial<TTalentForm>;
};

export const TalentCertificateFiles: FCC<TTalentCertificateFilesProps> = ({ defaultValues }) => {
  const { expanded, toggle } = useCollapsible();
  const resolveTags = useResolveDocumentTags();

  return (
    <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <CollapsibleSectionHeader title="証明書など" expanded={expanded} onToggle={toggle} />
      <Collapse in={expanded}>
        {defaultValues?.talentUploadFiles?.length ? (
          <Stack>
            {defaultValues.talentUploadFiles.map((item, idx) => (
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  mt: 2,
                }}
              >
                <TalentFileItem
                  currentFileIndex={idx}
                  files={defaultValues.talentUploadFiles}
                  filePath={item.filePath}
                  previewEnabled
                  downloadable={true}
                  maxWidth={336}
                  updatedAt={item.updatedAt}
                />
                <DocumentTypeTagsReadOnly tags={resolveTags(item.attachmentDocumentTypeIds)} />
              </Box>
            ))}
          </Stack>
        ) : null}
      </Collapse>
    </InnerBox>
  );
};
